import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import SelectBox, { ToolbarItem } from 'devextreme-react/select-box';
import NumberBox from 'devextreme-react/number-box';
import Form, { CustomRule, Item, Label, RequiredRule } from 'devextreme-react/form';
import dxForm from 'devextreme/ui/form';
import axios from 'axios';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button, CheckBox, DataGrid, DateBox, LoadPanel, Lookup, Popup, ScrollView, TextArea, TextBox, Toolbar } from 'devextreme-react';
import { DataGridTypes, Item as DgItem, Toolbar as DgToolbar  } from 'devextreme-react/data-grid';

import notify from 'devextreme/ui/notify';
import { Editing, Scrolling, Column } from 'devextreme-react/data-grid';
import dxDataGrid from 'devextreme/ui/data_grid';
import './customRechnung.scss';

interface CustomRechnungProps {
  customInvoiceItems: any[]; // replace with proper type
  onCustomInvoiceItemsChange: (items: any[]) => void;
  customInvoiceAddress: string; // replace with proper type
  onCustomInvoiceAddressChange: (addres: string) => void;
  customInvoiceIsCancellation: boolean;
  onCustomInvoiceIsCancellationChange: (isCancel: boolean) => void;
  customInvoiceOldNumber: string;
  onCustomInvoiceOldNumberChange: (oldNumber: string) => void;
  customInvoiceOldDate: string;
  onCustomInvoiceOldDateChange: (oldDate: string) => void;
}

// const CustomRechnung = () => {
const CustomRechnung: React.FC<CustomRechnungProps> = ({ 
  customInvoiceItems, onCustomInvoiceItemsChange, 
  customInvoiceAddress, onCustomInvoiceAddressChange,
  customInvoiceIsCancellation, onCustomInvoiceIsCancellationChange, 
  customInvoiceOldNumber, onCustomInvoiceOldNumberChange,
  customInvoiceOldDate, onCustomInvoiceOldDateChange
}) => {

  const baseUrl = process.env.REACT_APP_API_URL;

  // const [invoiceItems, setInvoiceItems] = useState<any[]>([]);
  const [invoice, setInvoice] = useState<{}>({});
  const [summary, setSummary] = useState<{}>({});
  const invoiceFormRef = useRef<dxForm>(null);
  const invoiceItemsGridRef = useRef<dxDataGrid>(null);
  const [newRowPosition, setNewRowPosition] = useState<DataGridTypes.NewRowPosition>('last');

  useEffect(() => {    
    // getUserData();
    // getBookingsById();
    // setIsViewMode(location.pathname.includes('view'));
    // setIsCopyMode(location.pathname.includes('copy'));
    // setIsEditMode(location.pathname.includes('edit'));
  }, []);

  const onFormInitialized = useCallback((e: any) => {
    invoiceFormRef.current = e.component;   
  }, []);  

  const onInvoiceItemsInitialized = useCallback((e: any) => {
    invoiceItemsGridRef.current = e.component;
  }, []);

  const onEditorPreparing = useCallback((e: any) => {
    if(e.dataField == "artikel" && e.parentType === "dataRow") {
      const defaultValueChangeHandler = e.editorOptions.onValueChanged;
      e.editorName = "dxTextArea"; // Change the editor's type
      e.editorOptions.onValueChanged = function (args: any) {  // Override the default handler
          defaultValueChangeHandler(args);
      }
    }
  }, []);

  const toast = useCallback((message: any, type: any = 'success') => {
    // console.log(message);
    notify({
      message: message,
      // position: {
      //   my: 'center top',
      //   at: 'center top',
      // },
    }, type, 3000);
  }, []);

  const NET_VAT_RATE = 0.19;

  // Netto sum (Zwischensumme / Gesamt netto)
  const totalNet = customInvoiceItems.reduce(
    (sum, item) => sum + (item.summe || 0),
    0
  );

  // VAT
  const vatAmount = totalNet * NET_VAT_RATE;

  // Gross total
  const totalGross = totalNet + vatAmount;

  const formatEUR = (value: number) =>
    new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
    }).format(value);

  return (
    <ScrollView>
      <div className="booking-form-content-block">
        <div className="dx-card responsive-paddings">
          {/* <h6 className="content-block-header" style={{marginTop: '0px', marginBottom: '20px', textAlign: 'center'}}>Buchungsformular</h6> */}
          <div id="booking-form-container">   
          {/* <button onClick={() => navigate('/bookings')} style={{ marginBottom: '10px' }}>
            <h6 style={{ margin: '0px' }}>← zurück zu Buchungen</h6>
          </button> */}
          <form action="your-action" onSubmit={(e) => e.preventDefault()}>
            <Form 
              id="invoice-form"
              formData={invoice}
              onInitialized={onFormInitialized}>
              <Item itemType="group" colCount={3} colSpan={2}>
                {/* Basic Information */}
                <Item itemType="group" colCount={2} colSpan={2} label={{ visible: false }}>
                  <Item colSpan={1} label={{ visible: false }}>
                    <CheckBox
                      text="Storno"
                      value={customInvoiceIsCancellation} // controlled by parent
                      onValueChanged={(e) => {
                        onCustomInvoiceIsCancellationChange(e.value); // update parent immediately
                      }}
                    />
                  </Item>
                  <Item itemType="empty" colSpan={1} label={{ visible: false }}></Item>
                  <Item colSpan={1} label={{ visible: false }}>
                    <TextArea
                      label="Adresse"
                      labelMode="static"
                      placeholder="Adresse"
                      autoResizeEnabled
                      value={customInvoiceAddress} // controlled by parent
                      onValueChanged={(e) => {
                        onCustomInvoiceAddressChange(e.value); // update parent immediately
                      }}
                      onKeyDown={(e) => {
                        if (e.event?.key === 'Enter') {
                          e.event.stopPropagation(); // prevent exiting on Enter
                        }
                      }}
                    />
                  </Item>
                  <Item itemType="empty" colSpan={1} label={{ visible: false }}></Item>
                  <Item colSpan={2} label={{ visible: false }}>
                    <div style={{ fontWeight: 700, fontSize: 18 }}>{!customInvoiceIsCancellation ? 'RECHNUNG' : 'STORNO-RECHNUNG FÜR AUFTRAG'}</div>
                  </Item>
                  {/* <Item itemType="empty" colSpan={1} label={{ visible: false }}></Item> */}
                  <Item dataField="Rechnung" colSpan={2} label={{ visible: false }}>
                    <Label location='left' />
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={{ whiteSpace: "pre" }}>
                        Rechnung:{"               "}KEP-&lt;wird generiert&gt;
                        {!customInvoiceIsCancellation ? "" : "(Storno für "}
                      </span>

                      {customInvoiceIsCancellation && (
                        <>
                          <TextBox
                            placeholder="Rechnungsnummer eingeben"
                            value={customInvoiceOldNumber} // controlled by parent
                            onValueChanged={(e) => onCustomInvoiceOldNumberChange(e.value)} // update parent
                            width={200} // optional fixed width
                          />
                          )
                        </>
                      )}
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span style={{ whiteSpace: "pre" }}>       
                        Rechnungsdatum:{"   "}{`${String(new Date().getDate()).padStart(2, "0")}.${String(
                        new Date().getMonth() + 1
                        ).padStart(2, "0")}.${new Date().getFullYear()}`}{!customInvoiceIsCancellation ? "" : "(zu Rechnung vom "}
                      </span>

                      {customInvoiceIsCancellation && (
                        <>
                          <TextBox
                            placeholder="Rechnungsdatum eingeben"
                            value={customInvoiceOldDate} // controlled by parent
                            onValueChanged={(e) => onCustomInvoiceOldDateChange(e.value)} // update parent
                            width={200} // optional fixed width
                          />
                          )
                        </>
                      )}
                    </div>
                    <div style={{ whiteSpace: "pre" }}>Zahlart:{"                   "}Rechnung</div>
                  </Item>                   
                </Item>

                {/* Pickup Information */}
                <Item itemType="group" caption="" colSpan={2}>
                  
                </Item>

                {/* Greeetings */}
                <Item itemType="group" colCount={1} colSpan={3}>
                  <Item colSpan={1} label={{ visible: false }}>
                  <div>
                    Sehr geehrte Damen und Herren,<br />
                    gemäß unserer Vereinbarung und den erbrachten Dienstleistungen<br />
                    stellen wir Ihnen folgende Positionen in Rechnung:
                  </div>
                  </Item>                                                  
                </Item>
                
                {/* Vehicle Information */}
                <Item itemType="group" colSpan={3}>
                  <DataGrid
                    id='invoiceGrid'
                    ref={invoiceItemsGridRef}
                    className={'dx-card content-block dx-datagrid-compact'}
                    dataSource={customInvoiceItems}
                    keyExpr="pos"
                    wordWrapEnabled={true}
                    focusedRowEnabled={true}
                    defaultFocusedRowIndex={0}
                    showBorders={true}
                    columnAutoWidth={true}
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    columnResizingMode="widget"
                    showColumnLines={true}
                    showRowLines={true}
                    rowAlternationEnabled={true}
                    columnHidingEnabled={true}
                    onInitialized={onInvoiceItemsInitialized}
                    onEditorPreparing={onEditorPreparing}
                    repaintChangesOnly={true}
                    onCellPrepared={(e) => {
                      if (e.rowType === 'data' && e.column.type === 'buttons' && e.data?.isBookingItem) {
                        const editBtn = e.cellElement.querySelector('.dx-link-edit') as HTMLElement;
                        const deleteBtn = e.cellElement.querySelector('.dx-link-delete') as HTMLElement;
                        if (editBtn) { editBtn.style.pointerEvents = 'none'; editBtn.style.opacity = '0.3'; }
                        if (deleteBtn) { deleteBtn.style.pointerEvents = 'none'; deleteBtn.style.opacity = '0.3'; }
                      }
                    }}
                    onSaving={(e) => {
                      if (!e.changes?.length) return;                    
                      let updatedItems = [...customInvoiceItems];                    
                      e.changes.forEach((change) => {                    
                        /* INSERT */
                        if (change.type === 'insert') {
                          const currentMaxPos = updatedItems.length
                            ? Math.max(...updatedItems.map(i => i.pos))
                            : 0;
                    
                          const newItem = {
                            ...change.data,
                            pos: currentMaxPos + 1,
                            summe: (change.data.anzahl || 0) * (change.data.preis || 0),
                          };                    
                          updatedItems.push(newItem);
                        }                    
                        /* UPDATE */
                        if (change.type === 'update') {
                          updatedItems = updatedItems.map(item => {
                            if (item.pos !== change.key) return item;
                    
                            const anzahl = change.data.anzahl ?? item.anzahl ?? 0;
                            const preis  = change.data.preis  ?? item.preis  ?? 0;
                    
                            return {
                              ...item,
                              ...change.data,
                              summe: anzahl * preis,
                            };
                          });
                        }                    
                        /* DELETE */
                        if (change.type === 'remove') {
                          updatedItems = updatedItems.filter(item => item.pos !== change.key);
                        }
                      });                    
                      onCustomInvoiceItemsChange(updatedItems);                    
                      e.cancel = true;
                    }}                    
                    onRowInserted={(e) => {
                      e.component.refresh(); // force refresh so sorting is applied
                    }}
                    onRowUpdating={(e) => {
                      const anzahl = e.newData.anzahl ?? e.oldData.anzahl ?? 0;
                      const preis  = e.newData.preis  ?? e.oldData.preis  ?? 0;
                  
                      e.newData.summe = anzahl * preis;
                    }}>
                    <Editing
                      refreshMode={'repaint'}
                      mode="row"
                      useIcons={true}
                      allowUpdating={true}
                      allowDeleting={true}
                      allowAdding={true}
                      newRowPosition={newRowPosition}
                      texts={{ confirmDeleteMessage: '' }}>
                    </Editing>
                    <DgToolbar>
                      <DgItem name="addRowButton" />
                    </DgToolbar>
                    <Scrolling useNative={true} showScrollbar="always" />
                    <Column dataField="pos" width={100} sortIndex={0} sortOrder="asc" allowEditing={false}/>
                    <Column dataField="artikel" allowEditing={true}/>
                    <Column dataField="anzahl" width={100} allowEditing={true} dataType="number"/>  
                    <Column dataField="preis" width={100} allowEditing={true} dataType="number"
                      format={{ type: 'currency', currency: 'EUR', precision: 2 }}
                      editorOptions={{ min: 0 }}/>
                    <Column dataField="summe" width={100} allowEditing={false} dataType="number"
                      format={{ type: 'currency', currency: 'EUR', precision: 2 }}
                      editorOptions={{ min: 0 }}/>
                  </DataGrid> 
                </Item>

                {/* Footer */}
                <Item itemType="group" colCount={2} colSpan={3}>
                  <Item itemType="empty" colSpan={1} label={{ visible: false }}></Item>
                  <Item colSpan={1} label={{ visible: false }}>
                  <div style={{ width: 220 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span>Zwischensumme (netto)</span>
                      <span>{formatEUR(totalNet)}</span>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span>Gesamt netto</span>
                      <span>{formatEUR(totalNet)}</span>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span>Umsatzsteuer (19 %)</span>
                      <span>{formatEUR(vatAmount)}</span>
                    </div>

                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        fontWeight: 'bold',
                        marginTop: 8,
                      }}
                    >
                      <span>Gesamtsumme</span>
                      <span>{formatEUR(totalGross)}</span>
                    </div>
                  </div>
                  </Item>   
                  <Item itemType="empty" colSpan={1} label={{ visible: false }}></Item>
                                               
                </Item>

                {/* Footer */}
                <Item itemType="group" colCount={1} colSpan={3}>
                  <Item colSpan={1} label={{ visible: false }}>
                  <div>
                    Wenn nicht anders angegeben, entspricht das Leistungsdatum dem Rechnungsdatum.<br />
                    <strong>Zahlbar innerhalb von 7 Tagen ab Rechnungsdatum ohne Abzug.</strong><br /><br />
                    Wir bedanken uns für Ihren Auftrag
                  </div>
                  </Item>                                                  
                </Item>
              </Item>                
            </Form> 
          </form>     
        </div>
        </div>
      </div>
    </ScrollView>
  );
};

export default CustomRechnung;
